// extracted by mini-css-extract-plugin
export default {"sticky":"StickyCta_sticky__6L9iV","fadeUp":"StickyCta_fadeUp__S4Nyl","hidden":"StickyCta_hidden__ywprj","dot":"StickyCta_dot__v5Jnp","pulse-dot":"StickyCta_pulse-dot__Xx70+"};